import React from 'react'
import { observable, action, runInAction, toJS } from 'mobx'
import { VIDEO_REVIEW } from '../../constant'
import API from '@api/bi_nuo/liveManage'
import { Button, Modal } from 'hljd'
import Style from './style.module.less'

const { confirm } = Modal

export default class Store {
  // 初始化变量
  initData = (id, liveStatus) => {
    this.channel_id = id
    this.liveStatus = liveStatus
  }

  // 直播抽奖
  @observable giftLists = []
  @observable winningUsersModalVisible = false
  @observable
  winningUsers = [
    {
      userId: '',
      nick: ''
    }
  ]

  @action
  getWinningUsers = async id => {
    const { success, data } = await API.giftRecordList({ id: id || '' })
    if (success) {
      runInAction(() => {
        this.winningUsers = (data && data.list) || []
        this.changeWinningUsersModalVisible()
      })
    }
  }

  @action
  changeWinningUsersModalVisible = () => {
    this.winningUsersModalVisible = !this.winningUsersModalVisible
  }

  @action
  getGiftLists = async () => {
    const { data, success } = await API.liveGiftList({
      channelId: this.channel_id
    })
    if (success) {
      runInAction(() => {
        this.giftLists = (data && data.list) || []
      })
    }
  }

  // 秒 ==> 时分秒
  getLimitTime = value => {
    let secondTime = parseInt(value) // 秒
    let minuteTime = 0 // 分
    let hourTime = 0 // 小时
    if (secondTime > 60) {
      //如果秒数大于60，将秒数转换成整数
      //获取分钟，除以60取整数，得到整数分钟
      minuteTime = parseInt(secondTime / 60)
      //获取秒数，秒数取佘，得到整数秒数
      secondTime = parseInt(secondTime % 60)
      //如果分钟大于60，将分钟转换成小时
      if (minuteTime > 60) {
        //获取小时，获取分钟除以60，得到整数小时
        hourTime = parseInt(minuteTime / 60)
        //获取小时后取佘的分，获取分钟除以60取佘的分
        minuteTime = parseInt(minuteTime % 60)
      }
    }
    let result = '' + parseInt(secondTime) + '秒'

    if (minuteTime > 0) {
      result = '' + parseInt(minuteTime) + '分' + result
    }
    if (hourTime > 0) {
      result = '' + parseInt(hourTime) + '小时' + result
    }
    return result
  }

  // 获取操作列
  getOperationDom = ({ winningNum, liveStatus, id, status }) => {
    let dom = [
      winningNum ? (
        <Button
          size="small"
          className={Style['text-button']}
          href="javascript:void(0)"
          onClick={() => this.getWinningUsers(id)}
        >
          中奖名单 ({winningNum})
        </Button>
      ) : (
        ''
      )
    ]
    if (liveStatus == VIDEO_REVIEW) {
      //直播结束
      const editDom = (
        <Button
          size="small"
          className={Style['text-button']}
          href="javascript:void(0)"
          onClick={() => this.editLiveLottery({ id, status: 'view' })}
        >
          编辑
        </Button>
      )
      dom.push(editDom)
    } else if (!winningNum && liveStatus != VIDEO_REVIEW) {
      //无中奖用户 && 直播未结束
      const editDom = (
        <Button
          size="small"
          className={Style['text-button']}
          href="javascript:void(0)"
          onClick={() => this.editLiveLottery({ id, status: 'edit' })}
        >
          编辑
        </Button>
      )
      const deleteDom = (
        <Button
          size="small"
          className={Style['text-button']}
          href="javascript:void(0)"
          onClick={() => this.deleteLiveLottery(id)}
        >
          删除
        </Button>
      )
      dom = dom.concat([editDom, deleteDom])
    } else if (winningNum && liveStatus != VIDEO_REVIEW) {
      //有中奖用户 && 直播未结束
      if (status == 2) {
        //礼物终止，只能查看，没有终止按钮
        const editDom = (
          <Button
            size="small"
            className={Style['text-button']}
            href="javascript:void(0)"
            onClick={() => this.editLiveLottery({ id, status: 'view' })}
          >
            编辑
          </Button>
        )
        dom = dom.concat([editDom])
      } else {
        const editDom = (
          <Button
            size="small"
            className={Style['text-button']}
            href="javascript:void(0)"
            onClick={() => this.editLiveLottery({ id, status: 'limit' })}
          >
            编辑
          </Button>
        )
        const stopDom = (
          <Button
            size="small"
            className={Style['text-button']}
            href="javascript:void(0)"
            onClick={() => this.stopLiveLottery({ id, status: '2' })}
          >
            终止
          </Button>
        )
        dom = dom.concat([editDom, stopDom])
      }
    }
    return dom
  }

  @observable liveLotteryModalVisible = false
  @observable liveLotteryModalInfo = {}

  @action
  updateData = data => {
    this.liveLotteryModalInfo = data
  }

  // 更改直播抽奖modal
  @action
  editLiveLottery = async ({ status = 'edit', id }) => {
    const modalStatus = status
    if (this.liveLotteryModalVisible) {
      this.liveLotteryModalVisible = !this.liveLotteryModalVisible
    } else {
      const { data, success } = await API.giftInfo({ id: id || '' })
      if (success) {
        runInAction(() => {
          this.liveLotteryModalInfo = Object.assign({}, data, { modalStatus })
          this.liveLotteryModalVisible = !this.liveLotteryModalVisible
        })
      }
    }
  }

  // 更改新增、编辑奖项
  @action
  emptyLiveLottery = () => {
    this.liveLotteryModalInfo = {
      giftName: undefined,
      rate: '',
      number: undefined,
      watchTime: ''
    }
    this.liveLotteryModalVisible = !this.liveLotteryModalVisible
  }

  // 表单控件change
  handleFormChange = changedFields => {
    const data = Object.assign({}, this.liveLotteryModalInfo, changedFields)
    this.updateData(data)
  }

  // 终止gift
  stopLiveLottery = async params => {
    confirm({
      title: '确认终止吗?',
      onOk: async () => {
        const { success } = await API.stopGift(params)
        if (success) {
          const index = toJS(this.giftLists).findIndex(
            item => item.id == params.id
          )
          const item = this.giftLists[index]
          item.status = '2'
          this.giftLists.splice(index, 1, item)
        }
      }
    })
  }

  // 删除gift
  deleteLiveLottery = async id => {
    const { success } = await API.deleteGift({ id: id || '' })
    if (success) {
      runInAction(() => {
        const index = toJS(this.giftLists).findIndex(item => item.id == id)
        this.giftLists.splice(index, 1)
      })
    }
  }
}
